import moment from 'moment-timezone';
import Log from './log';

export default class Showtimes {
  constructor() {
    this.showtimes = $('.js-showtime');

    if (this.showtimes.length) {
      this.checkShowtimes();

      this.showtimes.on('click', (event) => {
        Log.track('Showtime', 'click', event.target.href, true);
      });
    }
  }

  checkShowtimes() {
    this.showtimes.each(function checkIfExpired() {
      const showtime = $(this);
      let time = showtime.data('time');
      if (time) {
        time = moment.tz(time, 'YYYY-MM-DD hh:mm', 'America/Chicago');
        if (Showtimes.isExpired(time)) {
          showtime.addClass('expired');
        }
      }
    });
  }

  static isExpired(then) {
    const now = moment.now();
    if (now > then) {
      return true;
    }
    return false;
  }
}
